import { Roles } from 'constants/roles';
import { useSelector } from 'react-redux';
import { getUserRole } from 'store/session/selectors';

export const useRolePermissions = (acccessList: Roles[]) => {
    const role = useSelector(getUserRole);

    return { hasAccess: role && acccessList.includes(role.name) };
};
